// src/hooks/useProblemNumbers.js
// The problem numbers that apply to this person's client (3.60.0): for
// Contacts' badge and Compose's warning. One small request, kept for 5
// minutes per browser tab (and forgotten when a number is marked).
// → classOf(number) → { cls: 'not_fax' | 'hard', label, source } | null
import { useEffect, useState, useCallback } from 'react';
import { useAuth } from './useAuth';
import { API_BASE } from '../firebase/config';

let cache = null;   // { at, key, classes }
export function forgetProblemClasses() { cache = null; }

export function useProblemNumbers() {
  const { getToken, effectiveInfo } = useAuth();
  const key = effectiveInfo?.accountId || '';
  const [classes, setClasses] = useState(cache && cache.key === key ? cache.classes : {});
  useEffect(() => {
    if (cache && cache.key === key && Date.now() - cache.at < 5 * 60000) { setClasses(cache.classes); return; }
    let gone = false;
    (async () => {
      try {
        const r = await fetch(`${API_BASE}/portal/problem-numbers/classes`, { headers: { Authorization: `Bearer ${await getToken()}` } });
        const j = await r.json();
        if (!r.ok || gone) return;
        cache = { at: Date.now(), key, classes: j.classes || {} };
        setClasses(cache.classes);
      } catch { /* no badge then */ }
    })();
    return () => { gone = true; };
  }, [getToken, key]);
  return useCallback(number => classes[String(number || '').replace(/\D/g, '').slice(-10)] || null, [classes]);
}
